import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    ui_card: {
        "& .MuiCardActionArea-root": {
            flexDirection: "column",
            flexGrow: 1,
        },
        "& .MuiCardContent-root": {
            flexGrow: 1,
        },
        display: "flex",
        flexDirection: "column",
    },
    ui_card__full_height: {
        height: "100%",
    },
    ui_card__full_width: {
        width: "100%",
    },
    ui_card__variant_default: {},
    ui_card__variant_error: {
        backgroundColor: palette.error.light,
        boxShadow: "none",
    },
    ui_card__variant_info: {
        "& .MuiLink-root": {
            color: palette.primary.main,
        },
        backgroundColor: palette.info.light,
        boxShadow: "none",
    },
    ui_card__variant_primary: {
        backgroundColor: palette.primary.main,
        color: palette.primary.contrastText,
    },
    ui_card__variant_primary_light: {
        backgroundColor: palette.primary.light,
        boxShadow: "none",
    },
    ui_card__variant_warning: {
        backgroundColor: palette.warning.light,
        boxShadow: "none",
    },
}));
//# sourceMappingURL=ui_card.css.js.map